import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { RiskScoreType } from '@/components/9_TradingRiskScore/types';

declare interface TradingRiskScoreObj {
    question: string | null;
    answer: RiskScoreType | null;
}
/**
 * @todo Api 回傳值
 */
export interface TradingRiskScoreViewDataResp extends GeneralResp {
    result: {
        tradingRiskScoreCheckbox: Array<TradingRiskScoreObj>;
        financialProduct: Array<string> | null;
    };
}

/**
 * @todo 交易風險能力評分表 ViewData
 */
const TradingRiskScoreViewData = (): Promise<TradingRiskScoreViewDataResp> => {
    const url = RouteUrlList.API_TradingRiskScoreViewData.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<TradingRiskScoreViewDataResp>) => {
        return res.data;
    });
};

export default TradingRiskScoreViewData;
